export const UPDATE_COLLECTIONS = 'UPDATE_COLLECTIONS';
export const updateCollections = (collections) => ({
    type: UPDATE_COLLECTIONS,
    data: {
        collections
    }
});
